import i18n from "~/plugins/i18n";
export default {
    fields: [
        {
            key: "_selected",
            label: "",
            sortable: false,
            active: true,
            fixed: true,
            filter: false,
            _filter: false,
        },
        {
            key: "id",
            label: "#",
            _style: "width:5%",
            sorter: true,
            filter: true,
            _filter: true,
        },
        {
            key: "uuid",
            label: "uuid",
            _style: "width:5%",
            sorter: true,
            filter: true,
            _filter: true,
            active: false,
            _active: false,
        },
        {
            key: "name",
            label: "Name",
            sorter: true,
            active: true,
            filter: true,
            _filter: true,
        },
        {
            key: "Landings",
            label: "Landings",
            sorter: false,
            active: true,
            filter: false,
            _filter: false,
        },
        {
            key: "active",
            label: "Active",
            sorter: true,
            active: true,
            filter: false,
            _filter: {
                active: false,
                value: null,
                condition: "is_equal_to",
                type: "select",
                options: [
                    { value: "1", label: i18n.t("active") },
                    { value: "0", label: i18n.t("disable") },
                ],
            },
        },
        {
            key: "country_id",
            label: "Country",
            sorter: true,
            active: true,
            filter: false,
            _filter: false,
        },
        {
            key: "recived",
            label: "Received",
            sorter: true,
            active: true,
            filter: false,
            _filter: false,
        },
        {
            key: "ok",
            label: "Ok",
            _style: "width:2%",
            sorter: true,
            active: true,
            filter: false,
            _filter: false,
        },
        {
            key: "avg",
            label: "Avg",
            sorter: true,
            active: true,
            filter: false,
            _filter: false,
            _style: "width:5%",
        },
        {
            key: "error",
            label: "Errors",
            sorter: true,
            active: true,
            filter: false,
            _filter: false,
        },
        {
            key: "duplicated",
            label: "Duplicates",
            sorter: true,
            active: true,
            filter: false,
            _filter: false,
        },
        {
            key: "cappingPercentatge",
            label: "Capping",
            sorter: true,
            active: true,
            filter: false,
            _filter: false,
            _style: "width:5%",
        },
        {
            key: "opened",
            label: "Openers",
            sorter: true,
            active: true,
            filter: false,
            _filter: false,
        },
        {
            key: "clicked",
            label: "Clickers",
            sorter: true,
            active: true,
            filter: false,
            _filter: false,
        },
        {
            key: "deferred",
            label: "Deferreds",
            sorter: true,
            active: true,
            filter: false,
            _filter: false,
        },
        {
            key: "cost",
            label: "Cost",
            sorter: true,
            active: true,
            filter: false,
            _filter: false,
        },
        {
            key: "api_key",
            label: "Api Key",
            sorter: true,
            active: false,
            _active: false,
            filter: false,
            _filter: true,
        },
        {
            key: "created_at",
            label: "Created At",
            active: true,
            sorter: false,
            filter: false,
            _filter: false,
            _style: "width:7%",
        },
    ],
    allFields: [],
    items: [],
    order: "desc",
    rows: 5,
    page: 1,
    total_pages: 1,
    loading: true,
    hover: true,
    pagination: true,
    sorter: {
        external: true,
        resetable: true
    },
    sorterValue: {},
    size: "sm",
    columnFilter: {
        external: true,
        lazy: true
    },
    columnFilterValue: {},
    itemsPerPageSelect: true,
    itemSelected: null,
    loadQueryFromUrl: true,
}